(() => {
  /*
   * CONCEPTとSERVICEの両方から同じJSを読み込んでも、
   * 初期化処理を重複登録しないようにする。
   */
  if (window.reiandoSliderLoaded) {
    return;
  }

  window.reiandoSliderLoaded = true;


  class ReiandoSlider {
    constructor(slider) {
      this.slider = slider;

      this.viewport = slider.querySelector(
        '[data-slider-viewport]'
      );

      this.track = slider.querySelector(
        '[data-slider-track]'
      );

      this.slides = Array.from(
        slider.querySelectorAll(
          '[data-slider-slide]'
        )
      );

      this.prevButton = slider.querySelector(
        '[data-slider-prev]'
      );

      this.nextButton = slider.querySelector(
        '[data-slider-next]'
      );

      this.dotsContainer = slider.querySelector(
        '[data-slider-dots]'
      );

      this.status = slider.querySelector(
        '[data-slider-status]'
      );

      this.dotClass =
        slider.dataset.sliderDotClass ||
        'reiando-slider__dot';

      this.currentSlide = 0;

      this.startX = 0;
      this.currentX = 0;
      this.isDragging = false;


      this.handlePrevious =
        this.handlePrevious.bind(this);

      this.handleNext =
        this.handleNext.bind(this);

      this.handleKeydown =
        this.handleKeydown.bind(this);

      this.handleTouchStart =
        this.handleTouchStart.bind(this);

      this.handleTouchMove =
        this.handleTouchMove.bind(this);

      this.handleTouchEnd =
        this.handleTouchEnd.bind(this);

      this.handleBlockSelect =
        this.handleBlockSelect.bind(this);


      this.bindEvents();
      this.update();
    }


    /*
     * イベント登録
     */
    bindEvents() {
      this.prevButton?.addEventListener(
        'click',
        this.handlePrevious
      );

      this.nextButton?.addEventListener(
        'click',
        this.handleNext
      );

      this.viewport?.addEventListener(
        'keydown',
        this.handleKeydown
      );

      this.viewport?.addEventListener(
        'touchstart',
        this.handleTouchStart,
        {
          passive: true
        }
      );

      this.viewport?.addEventListener(
        'touchmove',
        this.handleTouchMove,
        {
          passive: true
        }
      );

      this.viewport?.addEventListener(
        'touchend',
        this.handleTouchEnd
      );

      this.viewport?.addEventListener(
        'touchcancel',
        this.handleTouchEnd
      );

      document.addEventListener(
        'shopify:block:select',
        this.handleBlockSelect
      );
    }


    /*
     * 前の画像
     */
    handlePrevious() {
      if (this.currentSlide <= 0) {
        return;
      }

      this.currentSlide -= 1;
      this.update();
    }


    /*
     * 次の画像
     */
    handleNext() {
      if (
        this.currentSlide >=
        this.slides.length - 1
      ) {
        return;
      }

      this.currentSlide += 1;
      this.update();
    }


    /*
     * キーボード操作
     */
    handleKeydown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.handlePrevious();
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.handleNext();
      }
    }


    /*
     * スワイプ開始
     */
    handleTouchStart(event) {
      if (
        this.slides.length <= 1 ||
        !event.touches?.length
      ) {
        return;
      }

      this.startX =
        event.touches[0].clientX;

      this.currentX =
        this.startX;

      this.isDragging = true;
    }


    /*
     * スワイプ中
     */
    handleTouchMove(event) {
      if (
        !this.isDragging ||
        !event.touches?.length
      ) {
        return;
      }

      this.currentX =
        event.touches[0].clientX;
    }


    /*
     * スワイプ終了
     */
    handleTouchEnd() {
      if (!this.isDragging) {
        return;
      }

      const distance =
        this.currentX - this.startX;

      const threshold = 50;

      if (distance > threshold) {
        this.handlePrevious();
      } else if (distance < -threshold) {
        this.handleNext();
      }

      this.isDragging = false;
      this.startX = 0;
      this.currentX = 0;
    }


    /*
     * テーマカスタマイズ画面で
     * 画像スライドブロックを選択したとき
     */
    handleBlockSelect(event) {
      const selectedSlide =
        event.target.closest?.(
          '[data-slider-slide]'
        );

      if (
        !selectedSlide ||
        !this.slider.contains(selectedSlide)
      ) {
        return;
      }

      const selectedIndex =
        this.slides.indexOf(selectedSlide);

      if (selectedIndex < 0) {
        return;
      }

      this.currentSlide = selectedIndex;
      this.update();
    }


    /*
     * ドット作成
     */
    createDots() {
      if (!this.dotsContainer) {
        return;
      }

      this.dotsContainer.innerHTML = '';

      this.slides.forEach(
        (slide, index) => {
          const dot =
            document.createElement('button');

          dot.type = 'button';
          dot.className = this.dotClass;

          dot.setAttribute(
            'data-slider-dot',
            ''
          );

          dot.setAttribute(
            'aria-label',
            `${index + 1}枚目の画像を表示`
          );

          if (index === this.currentSlide) {
            dot.classList.add('is-active');

            dot.setAttribute(
              'aria-current',
              'true'
            );
          }

          dot.addEventListener(
            'click',
            () => {
              this.currentSlide = index;
              this.update();
            }
          );

          this.dotsContainer.appendChild(dot);
        }
      );
    }


    /*
     * スライド位置更新
     */
    updateTrack() {
      if (!this.track) {
        return;
      }

      const translatePercent =
        this.currentSlide * 100;

      this.track.style.transform =
        `translateX(-${translatePercent}%)`;

      this.slides.forEach(
        (slide, index) => {
          const isVisible =
            index === this.currentSlide;

          slide.setAttribute(
            'aria-hidden',
            isVisible ? 'false' : 'true'
          );
        }
      );
    }


    /*
     * 矢印ボタン状態更新
     */
    updateButtons() {
      if (
        !this.prevButton ||
        !this.nextButton
      ) {
        return;
      }

      this.prevButton.disabled =
        this.currentSlide === 0;

      this.nextButton.disabled =
        this.currentSlide ===
        this.slides.length - 1;
    }


    /*
     * 読み上げ用ステータス更新
     */
    updateStatus() {
      if (!this.status) {
        return;
      }

      this.status.textContent =
        `${this.currentSlide + 1} / ${this.slides.length}`;
    }


    /*
     * 全体更新
     */
    update() {
      if (
        !this.track ||
        this.slides.length === 0
      ) {
        return;
      }

      if (this.currentSlide < 0) {
        this.currentSlide = 0;
      }

      if (
        this.currentSlide >
        this.slides.length - 1
      ) {
        this.currentSlide =
          this.slides.length - 1;
      }

      this.createDots();
      this.updateTrack();
      this.updateButtons();
      this.updateStatus();
    }


    /*
     * イベント解除
     */
    destroy() {
      this.prevButton?.removeEventListener(
        'click',
        this.handlePrevious
      );

      this.nextButton?.removeEventListener(
        'click',
        this.handleNext
      );

      this.viewport?.removeEventListener(
        'keydown',
        this.handleKeydown
      );

      this.viewport?.removeEventListener(
        'touchstart',
        this.handleTouchStart
      );

      this.viewport?.removeEventListener(
        'touchmove',
        this.handleTouchMove
      );

      this.viewport?.removeEventListener(
        'touchend',
        this.handleTouchEnd
      );

      this.viewport?.removeEventListener(
        'touchcancel',
        this.handleTouchEnd
      );

      document.removeEventListener(
        'shopify:block:select',
        this.handleBlockSelect
      );
    }
  }


  /*
   * 対象スライダー取得
   */
  function getReiandoSliders(
    root = document
  ) {
    const sliders = [];

    if (
      root instanceof Element &&
      root.matches('[data-reiando-slider]')
    ) {
      sliders.push(root);
    }

    root
      .querySelectorAll?.(
        '[data-reiando-slider]'
      )
      .forEach((slider) => {
        sliders.push(slider);
      });

    return [...new Set(sliders)];
  }


  /*
   * スライダー初期化
   */
  function initializeReiandoSliders(
    root = document
  ) {
    const sliders =
      getReiandoSliders(root);

    sliders.forEach((slider) => {
      if (
        slider.dataset
          .reiandoSliderInitialized ===
        'true'
      ) {
        return;
      }

      slider.dataset
        .reiandoSliderInitialized =
        'true';

      slider.reiandoSlider =
        new ReiandoSlider(slider);
    });
  }


  /*
   * 通常ページ読み込み
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initializeReiandoSliders();
      }
    );
  } else {
    initializeReiandoSliders();
  }


  /*
   * Shopifyテーマエディター
   */
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeReiandoSliders(
        event.target
      );
    }
  );


  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      const sliders =
        getReiandoSliders(event.target);

      sliders.forEach((slider) => {
        if (!slider.reiandoSlider) {
          return;
        }

        slider.reiandoSlider.destroy();

        slider.dataset
          .reiandoSliderInitialized =
          'false';

        delete slider.reiandoSlider;
      });
    }
  );
})();